import { Component, Vue } from 'vue-property-decorator';
import { confirm, alert } from 'devextreme/ui/dialog';
import { userManager } from '@/container';
import { User } from 'oidc-client';

@Component
export default class BaseMixin extends Vue {
	getTextBoxProps(readonly = false): Record<string, unknown> {
		return {
			stylingMode: readonly ? 'filled' : 'outlined',
			readOnly: readonly,
			height: '35px'
		};
	}

	// async onBeforeSend(...[, ajaxSettings]: Parameters<NonNullable<Options['onBeforeSend']>>): Promise<void> {
	// 	ajaxSettings.headers = {
	// 		...ajaxSettings.headers,
	// 		...await this.getAuthorizationHeaders()
	// 	};
	// }


	// async getAuthorizationHeaders(): Promise<Record<string, unknown>> {
	// 	const user: User | null = await userManager.getUser();

	// 	return user === null ? {} : {
	// 		Authorization: `Bearer ${user.access_token}`
	// 	};
	// }
	async getAuthorizationHeaders(): Promise<string> {
		const user: User | null = await userManager.getUser();

		return user === null ? '' : user.access_token;
	}

	// eslint-disable-next-line no-empty-function
	confirmDialog(captionMessage: string, onConfirmed: () => void, onNotConfimerd: () => void = () => { }) {
		confirm(captionMessage, this.$t('attention'))
			.then((value) => {
				if (value)
					onConfirmed();
				else
					onNotConfimerd();
			});
	}

	alertDialog(captionMessage: string): Promise<void> {
		return alert(captionMessage, this.$t('attention'));
	}
}
